/**
 * @file verification-rows.ts
 * @description Строки ввода кодов подтверждения (phase19.16, партия Р3в,
 * v0.19.64; SEO1): каждая строка — код или мета-тег целиком; наружу —
 * разобранные shared `parseVerificationCode` коды без повторов и признак
 * «есть неразборчивые непустые строки» (сохранять нельзя).
 */

import { parseVerificationCode, type SeoVerificationEngine } from "@chaiberi/shared";

export function parseVerificationRows(rows: readonly string[], engine: SeoVerificationEngine): { codes: string[]; invalid: boolean } {
  const codes: string[] = [];
  let invalid = false;
  for (const row of rows) {
    if (!row.trim()) continue;
    const code = parseVerificationCode(row, engine);
    if (code === null) invalid = true;
    else if (!codes.includes(code)) codes.push(code);
  }
  return { codes, invalid };
}
